import * as types from "../types";

export const getSponsors = () => ({
  type: types.GET_SPONSORS,
  request: {
    url: "/exhibitors",
    method: "GET",
    params: {
      "q[sponsor_level_not_null]": true,
      "q[order_by_sponsor]": true
    }
  }
});

export const getExhibitors = () => ({
  type: types.GET_EXHIBITORS,
  request: {
    url: "/exhibitors",
    method: "GET",
    params: {
      "q[order_by_sponsor]": true
    }
  }
});

export const getExhibitor = ({ id }) => ({
  type: types.GET_EXHIBITOR,
  request: {
    url: `/exhibitors/${id}`,
    method: "GET"
  }
});

export const updateExhibitor = ({ id, exhibitor }) => ({
  type: types.UPDATE_EXHIBITOR,
  request: {
    url: `/exhibitors/${id}`,
    method: "PATCH",
    data: {
      exhibitor
    }
  },
  meta: {
    mutations: {
      [types.GET_EXHIBITOR]: ({ data }) => {
        return { data: { ...data, ...exhibitor } };
      }
    }
  }
});
